/** zh-CN catalogue `import` (W3-09; English: src/features/import/import.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'import',
  locale: 'zh-CN',
  messages: {
    cmdImport: '打开谱面文件…',
    cmdImportFolder: '打开谱面文件夹…',
    cmdImportSummary: '显示上次的导入报告',
    cmdCancelImport: '取消剩余的导入',
    reasonNoSummary: '本次会话中还没有导入任何内容。',
    reasonNotRunning: '当前没有正在进行的导入。',
    bannerRunning: '正在导入第 {index} 个，共 {total} 个：{name}',
    bannerRunningOne: '正在导入 {name}',
    bannerWaiting: '等待你的选择：{name}',
    progressLabel: '导入进度',
    cancel: '取消',
    cancelImports: '取消剩余的导入',
    bannerDone:
      '导入完成：{created, plural, =0 {没有新项目} other {# 个新项目}}{failed, plural, =0 {} other {，# 个文件未导入}}。',
    viewReport: '查看报告',
    dismiss: '关闭',
    toastQueued: '又有 {count, plural, other {# 张谱面}}加入了导入队列。',
    toastCancelled: '已取消 {count, plural, other {# 项导入}}。',
    toastNothing: '这些文件中没有可导入的内容。',
    toastSkipped: '已略过 {count, plural, other {# 个文件}}：它们不在谱面文件夹中。',
    toastCreated: '已将 {name} 导入为新项目。',
    toastFailed: '无法导入 {name}：{error}',
    errorUnexpected: '导入意外停止：{error}',
    createFailed: '无法保存项目：{error}',
    openFailed: '导入的项目已在谱面库中，但无法打开：{error}',
    unknownError: '未知错误',
    reportTitle: '准备打开“{name}”',
    formatRpe: 'RPE',
    formatPgr1: 'Phigros 官方格式 1',
    formatPgr3: 'Phigros 官方格式 3',
    formatPec: 'PhiEditer（PEC）',
    rpeVersionPart: 'RPEVersion {version}',
    linesPart: '{count, plural, other {# 条判定线}}',
    notesPart: '{count, plural, other {# 个音符}}',
    eventsPart: '{count, plural, other {# 个事件}}',
    manifestPart: '清单：{source, select, yml {info.yml} txt {info.txt} csv {info.csv} other {取自谱面}}',
    phiraLoads: 'Phira 能否加载此文件：能',
    phiraRefuses:
      'Phira 能否加载此文件：不能。编辑器已修复 Phira 会拒绝或因之崩溃的内容（见“已更改”）；分享前请重新导出谱面。',
    exactSummary:
      '已精确加载：{events, plural, other {# 个事件}}、{notes, plural, other {# 个音符}}、{files, plural, =0 {没有文件} other {# 个文件}}{missing, plural, =0 {} other {（缺失 # 个）}}。',
    classExact: '精确加载',
    classNormalized: '已规范化（在 Phira 中显示相同）',
    classChanged: '已更改（Phira 会崩溃、拒绝，或依赖播放历史）',
    classFlagged: '已保留但已标记',
    classRpeOnly: 'Phira 不使用，为 RPE 保留',
    entryTimes: '{count, plural, other {# 次}}',
    entryLine: '判定线 {line}',
    moreEntries: '还有 {count, plural, other {# 条}}：复制或保存报告即可查看全部。',
    phiraWarnings: 'Phira 导入此文件时会显示以下警告：',
    openAs: '打开方式',
    openNew: '新项目',
    openNewHelp: '创建一个新项目。不会更改任何已有内容。',
    openMerge: '添加到当前项目',
    openMergeHelp: '其判定线、音符、分组及其使用的文件会添加到下方的拍数处。',
    mergeBeat: '在拍数',
    mergeAtPlayhead: '播放头',
    mergeAlign: '对齐方式',
    alignAuto: '自动（速度一致时按拍数，否则按曲目时间）',
    alignBeats: '按拍数（音符保持其节拍网格）',
    alignMusic: '按曲目时间（应用两张谱面的速度和偏移）',
    showInProblems: '打开并在“问题”中显示',
    copyReport: '复制报告',
    saveReport: '保存报告',
    reportCopied: '已复制报告。',
    copyFailed: '浏览器不允许复制到剪贴板。',
    open: '打开',
    add: '添加',
    reportFileName: '{name} 导入报告.txt',
    txnMerge: '添加 {name} 的判定线',
    toastMerged: '已从 {name} 添加 {lines, plural, other {# 条判定线}}。',
    mergeNoProject: '请先打开一个项目，再将谱面添加进去。',
    versionBeforeImport: '导入 {name} 之前',
    skinTitle: '安装皮肤“{name}”？',
    skinTitleInvalid: '无法安装此资源包',
    skinBy: '作者：{author}',
    skinHitFx: '打击特效：{cols} x {rows} 帧，{duration} 秒',
    skinSounds: '自带音效：{list}',
    skinNoSounds: '使用默认打击音。',
    skinImages: '皮肤的图片',
    skinErrors: 'Phira 会拒绝此资源包：',
    skinWarnings: '注意：',
    skinUseNow: '立即在预览中使用',
    skinInstall: '安装',
    skinInstalled: '已安装皮肤“{name}”。',
    skinInstallFailed: '无法安装皮肤。',
    imageAlt: '皮肤的 {name} 图片',
    batchTitle: '一个文件中的多张谱面',
    batchBody:
      '此文件包含 {count, plural, other {# 张谱面}}（Phira 批量导出，或 Phiedit 的全部谱面备份）。请选择要导入的谱面；每张都会成为独立的项目。',
    batchSelectAll: '全选',
    batchList: '文件中的谱面',
    batchImport: '导入{count, plural, =0 {谱面} other { # 张谱面}}',
    batchNone: '请至少选择一张谱面。',
    sizeB: '{size} B',
    sizeKB: '{size} kB',
    sizeMB: '{size} MB',
    sizeGB: '{size} GB',
    plainName: '{name}',
    summaryTitle: '导入报告',
    summaryIntro: '本次导入共 {count, plural, other {# 个文件}}。',
    outcomeProject: '新项目：{title}',
    outcomeMerged: '已从 {name} 向打开的谱面添加 {lines, plural, other {# 条判定线}}',
    outcomeSkin: '已安装皮肤：{name}',
    outcomeSkinSkipped: '未安装皮肤：{name}',
    outcomeBatch: '批量导出：已选择 {picked} 张，共 {total} 张',
    outcomeMedia: '只有媒体文件（{count, plural, other {# 个文件}}）：未找到谱面。',
    outcomeMediaStarted: '媒体文件已交给新建向导',
    startChart: '用它们新建谱面',
    outcomeCancelled: '未导入（已取消）',
    outcomeFailed: '未导入：{error}',
    classCounts: '已更改 {changed} · 已规范化 {normalized} · 已标记 {flagged}',
    outcomeList: '导入的文件',
    openProject: '打开',
    showReport: '报告',
    importMore: '导入更多',
    dropHere: '将 .pez 或 .zip 谱面包、谱面文件或整个文件夹拖放到任意位置，或在此处选择。',
    chooseFiles: '选择文件…',
    chooseFolder: '选择文件夹…',
    close: '关闭',
    settingAlign: '将导入的谱面添加到打开的谱面时的对齐方式',
    helpTitle: '打开与导入谱面',
    helpBody:
      '将 .pez 或 .zip 谱面包、RPE 谱面（.json）、Phigros 官方谱面、PhiEditer 谱面（.pec）或整个文件夹拖放到任意位置，或按 Ctrl+O。多个文件或文件夹会依次导入，每个都成为独立的项目，最后给出一份报告。\n\n导入报告会说明哪些内容被精确加载、哪些被规范化（Phira 中显示相同）、哪些因为 Phira 会崩溃或拒绝而被更改，以及哪些只为 RPE 保留。导入永远不会覆盖项目：可以选择新建项目，或将谱面添加到打开的谱面中的某一拍。\n\nPhira 资源包会安装为皮肤；单独的曲目或图片会启动新建向导。',
    alsoRead: '同时读取：{list}',
    featControls: '{count, plural, other {# 条带距离控制的判定线}}',
    featEffects: 'extra.json {count, plural, other {# 个特效}}{custom, plural, =0 {} other {（# 个自定义着色器）}}',
    featGif: '{count, plural, other {# 条 GIF 线}}',
    featPaint: '{count, plural, other {# 条画笔线}}',
    featParents: '{count, plural, other {# 个父线关系}}',
    featTempo: '{count, plural, other {# 个速度变化}}',
    featText: '{count, plural, other {# 条文字线}}',
    featTexture: '{count, plural, other {# 条图片线}}',
    featUi: '{count, plural, other {# 条 UI 绑定线}}',
    featVideos: '{count, plural, other {# 个视频}}',
    reportTextTitle: '“{name}”的导入报告',
    toastFailedMany: '有 {count, plural, other {# 个文件}}无法导入：{names}。',
  },
};

export default catalog;
